module.exports = require("./so-DJ.d.ts");